import { render, staticRenderFns } from "./OrticInputPercentage.vue?vue&type=template&id=1032fd92&"
import script from "./OrticInputPercentage.vue?vue&type=script&lang=js&"
export * from "./OrticInputPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports